import React,{useState,createContext,useContext} from 'react';

export const StepperContext = createContext();

export const StepperProvider = ({children}) => {
    const [currentStep,setCurrentStep] = useState(1)
    const handleNext = (steps) => {
        if(currentStep < steps.length){
            setCurrentStep(currentStep + 1)
        }
    }
    const handlePrevious = () => {
        if(currentStep>1){
            setCurrentStep(currentStep - 1)
        }
    }
    return (
        <StepperContext.Provider value={{currentStep,handleNext,handlePrevious}}>
            {children}
        </StepperContext.Provider>
    )
}

export const useStepper = () => {
    return useContext(StepperContext)
}